module.exports = __webpack_public_path__ + "static/media/norrisheader_01.79e8d3f1.png";